import styled from '@emotion/styled';
import { Typography } from 'src/components-dummy';

export const NotificationCardMessageTypographyStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.black};
  word-break: break-word;
`;
